"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRequestHeader = void 0;
/**
 * Request headers that are used through out the system
 */
exports.IkeRequestHeader = {
    /** Information about the application that is making the request, useful for debugging */
    REQUESTER: 'X-Ike-Requester',
    /** A unique id that is present through all requests and sub requests, used to trace the full flow of a request */
    RAY_ID: 'X-Ike-Ray-Id',
    /** The department that the request should use */
    DEPARTMENT: 'X-Ike-Department-Id',
    /** File name for file uploads */
    FILE_NAME: 'X-Ike-File-Name',
    /** JSON encoded extra arguments for the request */
    REQUEST_ARGS: 'X-Ike-Args',
    /**
     * Ike server information
     *
     * Exposes build and hostId
     *
     * @example 2048_445935fec30a
     */
    SERVER: 'X-Ike-Server',
    /**
     * The IKE4 device provides information about itself using `X-Ike-Device-*` headers
     */
    DEVICE_OS: 'X-Ike-Device-OS',
    DEVICE_H1: 'X-Ike-Device-H1',
    DEVICE_CONFIG_HASH: 'X-Ike-Device-Config-Hash',
    DEVICE_RAY: 'X-Ike-Device-Ray',
    DEVICE_SERIAL: 'X-Ike-Device-Serial',
    DEVICE_VERSION: 'X-Ike-Device-Version',
    DEVICE_MODEL: 'X-Ike-Device-Model',
    /** Common normal request headers */
    AUTHORIZATION: 'Authorization',
    CONTENT_TYPE: 'Content-Type',
    CONTENT_LENGTH: 'Content-Length',
    USER_AGENT: 'User-Agent',
    /** Unique request id for every request */
    REQUEST_ID: 'X-Request-Id'
};
//# sourceMappingURL=header.js.map